import { Doughnut } from 'react-chartjs-2';


export default function Doughnot({ vulns, vulnsAddressed}) {
    const data = {
        labels: [],
        datasets: [{
            label: "",
            data: [vulns-vulnsAddressed, vulnsAddressed],
            backgroundColor: [window.getColor("high-half"), window.getColor("none-half")]
        }]
    }
    const option = {
        onHover: (event, chart) => {
            setCurserPointerOnHover(event, chart.length)

        },
        datasets: {
            doughnut: {
                cutout: "90%",
                borderRadius: 50,
            },
        },
        elements: {
            arc: {
                borderColor: "",
                borderWidth: 0
            }
        },
    }
       const setCurserPointerOnHover = (event, isOnhover) => {
        if(isOnhover) {
            event.native.target.style.cursor = "pointer"

        } else {
            event.native.target.style.cursor = "default"
        }
    }
    return <Doughnut options={option} data={data}/>
}


